// extracted by mini-css-extract-plugin
module.exports = {"banner":"_gy","banner__img":"_gz","wrapper":"_gA","timer":"_gB"};